// Team Live header (approved HTML: 11-Team-Live-Consistency-Review-v4,
// component "team-live-header"). Read-only snapshot banner.
import type { ReactNode } from 'react';

export interface TeamLiveHeaderProps {
  snapshotDate: string;
  /** W37b: "DESIGN PREVIEW" for the fixture, "LIVE SNAPSHOT" on a real session. */
  snapshotLabel?: string;
}

export function TeamLiveHeader({ snapshotDate, snapshotLabel = 'DESIGN PREVIEW' }: TeamLiveHeaderProps): ReactNode {
  return (
    <section className="hero-new" data-component="team-live-header">
      <div>
        <span className="eyebrow">100X SALES WORKSPACE</span>
        <h1>Team Live</h1>
        <p>See who is working, where customers are waiting, and what needs your judgment.</p>
      </div>
      <span className="snapshot">
        {snapshotLabel}
        <br />
        {snapshotDate}
      </span>
    </section>
  );
}
